import { render, staticRenderFns } from "./reviewed.vue?vue&type=template&id=a40085ec&scoped=true&"
import script from "./reviewed.vue?vue&type=script&lang=js&"
export * from "./reviewed.vue?vue&type=script&lang=js&"
import style0 from "@/styles/common.scss?vue&type=style&index=0&id=a40085ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40085ec",
  null
  
)

export default component.exports